/**
 * Query to fetch allegati with pagination
 */
const allegatiQuery = `
query AllegatiQuery($first: Int!, $skip: Int, $where: AllegatiWhereInput, $order: [AllegatiOrder!]) {
  allegatis(
    first: $first,
    skip: $skip,
    where: $where,
    order: $order
  ) {
    count
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        objectId
        nome
        mimeType
        size_bytes
        condiviso
        provino
        createdAt
        updatedAt
        allegato {
          __typename
          name
          url
        }
        org_pointer {
          objectId
          nome
        }
        defunto_pointer {
          objectId
          nome
          cognome
        }
        office_pointer {
          objectId
        }
        isAiEdit
        isAutoColor
        isBlurBg
        isChangeClothes
        isColorizeBw
        isExpand
        isImageEnhancement
        isMagicEraser
        isRemovebg
        isSmile
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default allegatiQuery;